import { render, staticRenderFns } from "./Urlify.vue?vue&type=template&id=2e2d6391"
import script from "./Urlify.vue?vue&type=script&lang=js"
export * from "./Urlify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports